import { Box, Typography } from '@mui/material'
import React from 'react'
import ImportTalentModal from './ImportTalentModal'
import external_banner from '../assets/external-banner.png'

const ImportTalentCard = () => {
    return (    
        <Box sx={{backgroundColor:'white.main', backgroundImage:`url(${external_banner})`,backgroundSize: 'cover', borderRadius: '4.5px', padding: '32px', marginBottom: '32px' }}>
            <Typography variant='h3' fontWeight='bold' sx={{ marginBottom: '16px' }}>Enhance Your External Talent Pool <br /> Management</Typography>
            <Typography sx={{ color: 'light-gray-text.main', marginBottom: '32px' }}>
                Manage your external talents' resumes, extract <br /> information with our resume parsing tool, and match to <br />job ads seamlessly.</Typography>
            <ImportTalentModal/>
        </Box>
    )
}

export default ImportTalentCard